import LocationNotes from '../navPages/LocationNotes'
import LocationProjects from '../navPages/LocationProjects'
import LocationAnalytics from '../navPages/LocationDemographics'
import LocationMaps from '../navPages/LocationMaps'
import LocationDocumentsCN from '../navPages/LocationDocumentsCN'
import LocationReports from '../navPages/LocationReports'
import LocationFinancials from '../../../features/Financials/screens/LocationFinancials'
import {
	FolderKanban,
	StickyNote,
	Map,
	DollarSign,
	BarChart3,
	FileText,
	FileBarChart,
} from 'lucide-react'
import routes from 'constants/routes'
import Locations_Edit from '../Locations_Edit'
import type { Capabilities } from '../../../utils/capabilities'

const getLocationRoutes = (id: string, capabilities?: Capabilities) => [
	{
		linkText: 'Projects ',
		linkTo: `${routes.LOCATIONS}/${id}/projects`,
		linkPattern: `${routes.LOCATIONS}/:id/projects`,
		icon: FolderKanban,
		component: LocationProjects,
	},
	{
		linkText: 'Notes ',
		linkTo: `${routes.LOCATIONS}/${id}/notes`,
		linkPattern: `${routes.LOCATIONS}/:id/notes`,
		icon: StickyNote,
		component: LocationNotes,
	},

	{
		linkText: 'Map',
		linkTo: `${routes.LOCATIONS}/${id}/maps`,
		linkPattern: `${routes.LOCATIONS}/:id/maps`,
		icon: Map,
		component: LocationMaps,
	},

	{
		linkText: 'Financials',
		linkTo: `${routes.LOCATIONS}/${id}/financials`,
		linkPattern: `${routes.LOCATIONS}/:id/financials`,
		icon: DollarSign,
		component: LocationFinancials,
	},

	{
		linkText: 'Demographics',
		linkTo: `${routes.LOCATIONS}/${id}/analytics`,
		linkPattern: `${routes.LOCATIONS}/:id/analytics`,
		icon: BarChart3,
		component: LocationAnalytics,
	},

	{
		linkText: 'Documents',
		linkTo: `${routes.LOCATIONS}/${id}/files`,
		linkPattern: `${routes.LOCATIONS}/:id/files`,
		icon: FileText,
		component: LocationDocumentsCN,
	},

	{
		linkText: 'Reports',
		linkTo: `${routes.LOCATIONS}/${id}/reports`,
		linkPattern: `${routes.LOCATIONS}/:id/reports`,
		icon: FileBarChart,
		component: LocationReports,
	},

	/*
		Redirect routes
	*/
	{
		linkPattern: `${routes.LOCATIONS}/:id/edit`,
		component: Locations_Edit,
	},
	{
		redirectFrom: `${routes.LOCATIONS}/:id`,
		redirectTo: `${routes.LOCATIONS}/${id}/projects`,
	},
	// Hide the Financials tab from accounts without financials access
	// (community). Omitting `capabilities` shows everything (pro default).
].filter((route: any) => {
	if (route.linkText === 'Financials' && capabilities && !capabilities.canSeeFinancials) {
		return false
	}
	return true
})

export default getLocationRoutes
